import { Box, Container, Grid2 as Grid, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import React, { useEffect, useRef } from 'react';

const PrivacyPolicy = ({ router }) => {

    const scrollToTopRef = useRef(null);
    useEffect(() => {
        scrollToTopRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);

    const navigateTo = (path) => {
        router.navigate(path); // This navigates to the specific page
    };

    return (
        <div ref={scrollToTopRef}>
            <Container maxWidth="lg" sx={{ minHeight: "1000px" }}>

                {/* BREADCRUMPS WIDGET START */}
                <Grid container spacing={1} >
                    <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{ margin: '10px' }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigateTo('/')}>
                                Home
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Prepayment Calculator</Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
                {/* BREADCRUMPS WIDGET ENDS */}

                <Box sx={{ padding: '20px' }}>
                    <Typography variant="h3" gutterBottom align="center">
                        Credits
                    </Typography>

                    <Typography variant="body1" paragraph>
                        The following resources have been used in the development of this website:
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        1. Icons
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <a href="https://www.flaticon.com/free-icons/budget" target="_blank" rel="noopener noreferrer">
                            Icons created by Freepik - Flaticon
                        </a>
                    </Typography>
                </Box>
            </Container>
        </div>
    );
};

export default PrivacyPolicy;
